import React from 'react'
import PropTypes from 'prop-types'
import { compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import BackIcon from '@material-ui/icons/ArrowBack'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'

import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'
import { styles } from './styles'
import { isMobile } from '../../utils'
import { resetPassword } from '../../stores/hero'
import { connect } from 'react-redux'

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    oldPassword: yup.string().required('Password is required'),
    newPassword: yup
      .string()
      .required('New password is required')
      .notOneOf(
        [yup.ref('oldPassword'), null],
        'Passwords must not same as current password'
      ),
    repeatPassword: yup
      .string()
      .required('Repeat password is required')
      .oneOf(
        [yup.ref('newPassword'), null],
        'Repeat passwords must same as new password'
      )
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { me, resetPassword, enqueueSnackbar } = props

  setSubmitting(true)

  const data = {
    id: me.id,
    password: values.newPassword,
    oldPassword: values.oldPassword
  }
  await resetPassword(data, enqueueSnackbar)
  setSubmitting(false)
}

export const ChangePassword = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  values,
  isSubmitting,
  history
}) => (
  <React.Fragment>
    <AppBar position="sticky">
      <Toolbar>
        <IconButton
          id="btnBack"
          color="inherit"
          aria-label="Menu"
          style={styles.menuButton}
          onClick={() => history.goBack()}>
          <BackIcon />
        </IconButton>
        <Typography
          id="titlePage"
          variant="h6"
          color="inherit"
          style={styles.grow}>
          เปลี่ยนรหัสผ่าน
        </Typography>
      </Toolbar>
    </AppBar>
    <main style={styles.main}>
      <form onSubmit={handleSubmit}>
        <Card elevation={isMobile ? 0 : 1} style={styles.card}>
          <CardContent style={{ textAlign: 'center' }}>
            <FormControl
              margin="normal"
              fullWidth
              error={touched.oldPassword && Boolean(errors.oldPassword)}>
              <TextField
                id="inputoldPassword"
                type="password"
                name="oldPassword"
                label="รหัสผ่านปัจจุบัน"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.oldPassword}
                error={touched.oldPassword && Boolean(errors.oldPassword)}
              />
              {touched.oldPassword && errors.oldPassword && (
                <FormHelperText>{errors.oldPassword}</FormHelperText>
              )}
            </FormControl>

            <FormControl
              margin="normal"
              fullWidth
              error={touched.newPassword && Boolean(errors.newPassword)}>
              <TextField
                id="newPassword"
                type="password"
                name="newPassword"
                label="รหัสผ่านใหม่"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.newPassword}
                error={touched.newPassword && Boolean(errors.newPassword)}
              />
              {touched.newPassword && errors.newPassword && (
                <FormHelperText>{errors.newPassword}</FormHelperText>
              )}
            </FormControl>

            <FormControl
              margin="normal"
              fullWidth
              error={touched.repeatPassword && Boolean(errors.repeatPassword)}>
              <TextField
                id="repeatPassword"
                type="password"
                name="repeatPassword"
                label="รหัสผ่านใหม่อีกครั้ง"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.repeatPassword}
                error={touched.repeatPassword && Boolean(errors.repeatPassword)}
              />
              {touched.repeatPassword && errors.repeatPassword && (
                <FormHelperText>{errors.repeatPassword}</FormHelperText>
              )}
            </FormControl>
          </CardContent>

          <CardActions style={styles.cardActions}>
            {isSubmitting ? (
              <Button disabled variant="contained" fullWidth>
                Updating...
              </Button>
            ) : (
              <Button
                fullWidth
                variant="contained"
                type="submit"
                color="primary">
                เปลี่ยนรหัสผ่าน
              </Button>
            )}
          </CardActions>
        </Card>
      </form>
    </main>
  </React.Fragment>
)

ChangePassword.propTypes = {
  history: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired
}

const mapDispatchToProps = {
  resetPassword
}

export default compose(
  withRouter,
  withSnackbar,
  withApollo,
  connect(null, mapDispatchToProps),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ me }) => {
      return {
        id: (me && me.id) || '',
        oldPassword: '',
        newPassword: ''
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'ChangePasswordForm'
  })
)(ChangePassword)



// WEBPACK FOOTER //
// ./src/pages/ChangePassword/index.js